export default __webpack_public_path__ + "static/media/frame_left_light.97fd0b2c.png";